import React from 'react';
import "./showdialogforpayment.css"
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';

export const ShowDialogForPayment = ({ refundItems, showDialog, setShowDialog }) => {
  const navigate = useNavigate();
  
    return (
    <Dialog
      header="Refund Initiated"
      visible={showDialog}
      onHide={() => setShowDialog(false)}
      footer={
        <button
        className="buttonfoeshowdialogpayments"
        onClick={() => {setShowDialog(false)
          navigate("/dashboard");   
          window.location.reload();              
        }}>
          Okay
        </button>
      }
    >
      <div>
        <span>
          Your cancellation is successful. You will get refund for:
        </span>
        <ul>
          {refundItems.length>0 && refundItems.map((item, index) => (
             <li key={index}>
    Type: {item.type}, Paid Amount: ₹{item.paid_amount}
  </li>
          ))}
        </ul>
        <span>for any details contact +91 7416734499</span>
      </div>
    </Dialog>
  );
};
